import React, { useState, useEffect, useRef } from "react";
import "./Profile_Expert.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import Account_Created_Modal from "../login/account-created-modal/Account_Created_Modal";
import { GETExpert, Update_Expert } from "../../../features/admin/auth/Slice";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  AllState,
  AllDistrict,
  AllProfession,
  AllSubProfession,
} from "../../../features/admin/common/Slice";
import { Form } from "react-bootstrap";
import { IDS } from "../../../utils/IDS";

const Profile_Expert = () => {
  const dispatch = useDispatch();

  const states = useSelector((state) => state?.common?.all_state);
  const districts = useSelector((state) => state?.common?.all_district);
  const professions = useSelector((state) => state?.common?.all_profession);
  const all_sub_profession = useSelector(
    (state) => state?.common?.all_sub_professions,
  );

  const expertGet = useSelector((state) => state?.auth?.login?.getExpertData);
  console.log(expertGet, "expertGetexpertGetexpertGetexpertGet");

  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState("personal");
  const [showSuccess, setShowSuccess] = useState(false);

  const [profileFile, setProfileFile] = useState(null);
  const [profileImage, setProfileImage] = useState(
    "/assets/images/profile-icon.png",
  );
  const [errors, setErrors] = useState({});

  const mapRef = useRef();
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const searchInputRef = useRef(null);
  const isEditingRef = useRef(false);

  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    mobile_number: "",
    whatsapp_no: "",
    experience: "",
    free_site_visit: 0,
    state: null,
    state_id: null,
    district: null,
    district_id: null,
    profession: [],
    sub_profession: [],
    lat: "",
    long: "",
  });

  // ====================== Fetch Initial Data ======================
  useEffect(() => {
    dispatch(GETExpert());
    dispatch(AllState());
    dispatch(AllProfession());
  }, [dispatch]);

  // ====================== Prefill Form ======================
  useEffect(() => {
    if (!expertGet) return;

    const professionsData =
      expertGet?.user_details?.profession?.map((item) => ({
        label: item.profession?.name,
        value: item.profession?.id,
      })) || [];

    const subProfessionsData =
      expertGet?.sub_profession?.map((item) => ({
        label: item?.sab_profession?.name,
        value: item?.sab_profession?.id,
        profession_id: item?.sab_profession?.profession_id,
      })) || [];

    setFormData({
      name: expertGet?.name || "",
      dob: expertGet?.user_details?.dob || "",
      mobile_number: expertGet?.mobile_number || "",
      whatsapp_no: expertGet?.user_details?.whatsapp_no || "",
      experience: expertGet?.user_details?.experience || "",
      free_site_visit: expertGet?.free_site_visit ? 1 : 0,
      profession: professionsData,
      sub_profession: subProfessionsData,
      state: expertGet?.user_details?.state
        ? {
            label: expertGet.user_details.state.name,
            value: expertGet.user_details.state.id,
          }
        : null,
      state_id: expertGet?.user_details?.state?.id || null,
      district: expertGet?.user_details?.district
        ? {
            label: expertGet.user_details.district.name,
            value: expertGet.user_details.district.id,
          }
        : null,
      district_id: expertGet?.user_details?.district?.id || null,
      lat: expertGet?.lat || "",
      long: expertGet?.long || "",
    });

    setProfileImage(
      expertGet?.profile_pic
        ? `${IDS.IMG_URL}${expertGet.profile_pic}`
        : "/assets/images/profile-icon.png",
    );

    setProfileFile(null);

    if (professionsData.length > 0) {
      dispatch(
        AllSubProfession({
          profession_id: professionsData.map((p) => p.value),
        }),
      );
    }
  }, [expertGet, dispatch]);

  // ====================== Fetch Sub Professions Dynamically ======================
  useEffect(() => {
    if (formData.profession?.length > 0) {
      const professionIds = formData.profession.map((item) => item.value);
      dispatch(AllSubProfession({ profession_id: professionIds }));
    } else {
      setFormData((prev) => ({ ...prev, sub_profession: [] }));
    }
  }, [formData.profession, dispatch]);

  // ====================== Styles ======================
  const selectStyles = {
    control: (base) => ({
      ...base,
      height: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      boxShadow: "none",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  // ====================== Handlers ======================
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleStateChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      state: selectedOption,
      state_id: selectedOption?.value || null,
      district: null,
      district_id: null,
    }));
    setErrors((prev) => ({ ...prev, state: "", district: "" }));

    if (selectedOption?.value) {
      dispatch(AllDistrict({ state_id: selectedOption.value }));
    }
  };

  const handleDistrictChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      district: selectedOption,
      district_id: selectedOption?.value || null,
    }));
    setErrors((prev) => ({ ...prev, district: "" }));
  };

  const handleProfessionChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      profession: selectedOptions || [],
      sub_profession: [],
    }));
    setErrors((prev) => ({ ...prev, profession: "" }));
  };

  const handleSubProfessionChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      sub_profession: selectedOptions || [],
    }));
    setErrors((prev) => ({ ...prev, sub_profession: "" }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfileFile(file);
      setProfileImage(URL.createObjectURL(file));
    }
  };

  const handleCheckboxChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      free_site_visit: e.target.checked ? 1 : 0,
    }));
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    else if (!/^[A-Za-z\s]+$/.test(formData.name))
      newErrors.name = "Name should not contain numbers";

    if (!formData.mobile_number.trim())
      newErrors.mobile_number = "Mobile number is required";
    else if (!/^\d{10}$/.test(formData.mobile_number))
      newErrors.mobile_number = "Enter valid 10 digit mobile number";

    if (!formData.dob) newErrors.dob = "Date of Birth is required";
    if (!formData.state_id) newErrors.state = "State is required";
    if (!formData.district_id) newErrors.district = "District is required";
    if (!formData.profession.length)
      newErrors.profession = "Profession is required";
    if (!formData.experience) newErrors.experience = "Experience is required";

    return newErrors;
  };

  const handleButtonClick = async () => {
    if (!isEditing) {
      setIsEditing(true);
      return;
    }

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formDataToSend = new FormData();

    formDataToSend.append("name", formData.name);
    formDataToSend.append("mobile_number", formData.mobile_number);
    formDataToSend.append("dob", formData.dob);
    formDataToSend.append("experience", formData.experience);
    formDataToSend.append("state_id", formData.state_id);
    formDataToSend.append("district_id", formData.district_id);
    formDataToSend.append("free_site_visit", formData.free_site_visit);
    formDataToSend.append("lat", formData.lat);
    formDataToSend.append("long", formData.long);
    // Profession and Sub Profession
    formData.profession.forEach((p) =>
      formDataToSend.append("profession[]", p.value),
    );

    console.log("Selected Sub Profession", formData.sub_profession);
    formData.sub_profession.forEach((sub) =>
      formDataToSend.append("sub_profession_id[]", sub.value),
    );

    if (profileFile) {
      formDataToSend.append("profile_pic", profileFile);
    }

    const res = await dispatch(Update_Expert(formDataToSend));
    if (res.meta?.requestStatus === "fulfilled") {
      dispatch(GETExpert());
      setShowSuccess(true);
      setIsEditing(false);
      setProfileFile(null);
    }
    console.log(res, "resresres");
  };
  // ====================== Map Effects ======================
  useEffect(() => {
    isEditingRef.current = isEditing;
  }, [isEditing]);

  useEffect(() => {
    if (expertGet && window.google && window.google.maps && mapRef.current) {
      initMap();
    }
  }, [expertGet]);

  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.setDraggable(isEditing);
    }
  }, [isEditing]);

  useEffect(() => {
    if (
      mapInstance.current &&
      markerRef.current &&
      formData.lat &&
      formData.long
    ) {
      const position = {
        lat: parseFloat(formData.lat),
        lng: parseFloat(formData.long),
      };
      mapInstance.current.setCenter(position);
      markerRef.current.setPosition(position);
    }
  }, [formData.lat, formData.long]);

  const initMap = () => {
    if (!mapRef.current) return;
    if (mapInstance.current) return;

    const position = {
      lat: parseFloat(formData.lat) || 18.5204,
      lng: parseFloat(formData.long) || 73.8567,
    };

    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      center: position,
      zoom: 15,
    });

    markerRef.current = new window.google.maps.Marker({
      position,
      map: mapInstance.current,
      draggable: isEditingRef.current,
    });

    markerRef.current.addListener("dragend", (e) => {
      if (!isEditingRef.current) return;
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      setFormData((prev) => ({
        ...prev,
        lat: lat.toString(),
        long: lng.toString(),
      }));
    });

    mapInstance.current.addListener("click", (e) => {
      if (!isEditingRef.current) return;
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      markerRef.current.setPosition({ lat, lng });
      setFormData((prev) => ({
        ...prev,
        lat: lat.toString(),
        long: lng.toString(),
      }));
    });

    initAutocomplete();
  };

  const initAutocomplete = () => {
    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInputRef.current,
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      mapInstance.current.setCenter({ lat, lng });
      markerRef.current.setPosition({ lat, lng });

      setFormData((prev) => ({
        ...prev,
        lat: lat.toString(),
        long: lng.toString(),
      }));

      searchInputRef.current.value = place.formatted_address;
    });
  };

  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => setShowSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showSuccess]);

  return (
    <div className="profile-wrapper">
      <div className="profile-container container">
        <div className="profile-card">
          <div className="profile-image-wrapper">
            <input
              type="file"
              id="profile-image-upload-expert"
              hidden
              accept="image/*"
              onChange={handleFileChange}
            />
            <img src={profileImage} alt="profile" className="profile-image" />
            <label
              htmlFor="profile-image-upload-expert"
              className="edit-icon"
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </label>
          </div>

          <div className="profile-form">
            {activeTab === "personal" && (
              <>
                <div className="form-row">
                  <div className="form-group">
                    <label>Full Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      disabled={!isEditing}
                    />
                    {errors.name && (
                      <span className="error-text">{errors.name}</span>
                    )}
                  </div>
                  <div className="form-group">
                    <label>DOB</label>
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleInputChange}
                      disabled={!isEditing}
                      max="9999-12-31"
                    />
                    {errors.dob && (
                      <span className="error-text">{errors.dob}</span>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <Select
                      isMulti
                      value={formData.profession}
                      options={professions}
                      styles={selectStyles}
                      isDisabled={!isEditing}
                      onChange={handleProfessionChange}
                      placeholder=""
                    />
                    {errors.profession && (
                      <span className="error-text">{errors.profession}</span>
                    )}
                    <label className="floating-label">Profession</label>
                  </div>

                  <div className="form-group">
                    <Select
                      isMulti
                      value={formData.sub_profession}
                      options={all_sub_profession}
                      styles={selectStyles}
                      isDisabled={!isEditing || !formData.profession.length}
                      onChange={handleSubProfessionChange}
                      placeholder=""
                    />
                    {errors.sub_profession && (
                      <span className="error-text">
                        {errors.sub_profession}
                      </span>
                    )}
                    <label className="floating-label">Sub Profession</label>
                  </div>

                  <div className="form-group">
                    <label>Mobile Number</label>
                    <input
                      type="text"
                      name="mobile_number"
                      value={formData.mobile_number}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        if (value.length <= 10) {
                          handleInputChange({
                            target: { name: "mobile_number", value },
                          });
                        }
                      }}
                      disabled={!isEditing}
                    />
                    {errors.mobile_number && (
                      <span className="error-text">{errors.mobile_number}</span>
                    )}
                  </div>
                </div>

                <div className="form-row d-block">
                  <div className="row">
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <Select
                          value={formData.state}
                          options={states}
                          styles={selectStyles}
                          isDisabled={!isEditing}
                          onChange={handleStateChange}
                          placeholder=""
                        />
                        {errors.state && (
                          <span className="error-text">{errors.state}</span>
                        )}
                        <label className="floating-label">State</label>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <Select
                          value={formData.district}
                          options={districts}
                          styles={selectStyles}
                          isDisabled={!isEditing || !formData.state}
                          onChange={handleDistrictChange}
                          placeholder=""
                        />
                        {errors.district && (
                          <span className="error-text">{errors.district}</span>
                        )}
                        <label className="floating-label">District</label>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-3">
                      <div className="form-group">
                        <label>Experience</label>
                        <input
                          type="text"
                          name="experience"
                          value={formData.experience}
                          onChange={handleInputChange}
                          disabled={!isEditing}
                        />
                        {errors.experience && (
                          <span className="error-text">
                            {errors.experience}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <input type="text" value={formData.lat} readOnly />
                        <label>Latitude</label>
                      </div>
                      <div className="form-group">
                        <input type="text" value={formData.long} readOnly />
                        <label>Longitude</label>
                      </div>
                    </div>

                    <div className="form-group">
                      <input
                        type="text"
                        ref={searchInputRef}
                        placeholder="Search Location"
                        disabled={!isEditing}
                      />
                    </div>

                    <div
                      ref={mapRef}
                      style={{
                        width: "100%",
                        height: "300px",
                        borderRadius: "10px",
                        marginTop: "10px",
                      }}
                    />

                    {/* <div className="col-md-12 mb-3">
                        <div className="checkbox-group">
                          <Form.Check
                            type="checkbox"
                            id="freeSiteVisit"
                            label="Free Site Visit Available"
                            checked={formData.free_site_visit === 1}
                            onChange={handleCheckboxChange}
                            disabled={!isEditing}
                          />
                        </div>
                      </div> */}
                  </div>
                </div>
              </>
            )}

            <button
              className={isEditing ? "save-profile-btn" : "edit-profile-btn"}
              onClick={handleButtonClick}
            >
              {isEditing ? "Save Profile" : "Edit Profile"}
            </button>
          </div>
        </div>
      </div>

      <Account_Created_Modal
        showAccountModal={showSuccess}
        handleAccountModalClose={() => setShowSuccess(false)}
        text="Profile Saved Successfully!"
      />
    </div>
  );
};

export default Profile_Expert;
